import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';
import useDidMountEffect from 'assets/js/useDidMountEffect';

/* MODAL */
import { useModal } from 'hooks/modalContext';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';
import CloseBtn from '../util/CloseModal'

const ClientTypeModal = props => {
  const { closeModal } = useModal();

  const [item, setItem] = useState({
    clientTypeSeq: '',
    clientTypeName: '',
  });
  const [isData, setIsData] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isIdCheck, setIsIdCheck] = useState(false);

  useEffect(() => {
    if (!props.props?.isRegi && !isData) {
      setItem(props.props?.data.item);
      setIsData(true);
      setIsIdCheck(true);
    }
  }, [props]);

  useDidMountEffect(() => {
    if (!props.props?.isRegi && item.clientTypeName === props.props?.data.item.clientTypeName) {
      setIsIdCheck(true);
    }
  }, [item]);

  const validation = () => {
    const msgArr = ['Client Type required.'];
    const columns = ['clientTypeName'];

    for (let i = 0; i < columns.length; i++) {
      if (Common.isEmpty(item[columns[i]])) {
        Common.errorMsg(msgArr[i]);

        return false;
      }
    }

    if (!isIdCheck) {
      Common.errorMsg('Client Type verification required.');

      return false;
    }

    return true;
  };

  const setClientType = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to save?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            const request = props.props?.isRegi ? Server.sendPost : Server.sendPatch;

            request('client/type', item, clientTypeSaveCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const clientTypeSaveCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  const clientTypeCheck = () => {
    if (isIdCheck) return;

    if (Common.isEmpty(item.clientTypeName)) {
      Common.errorMsg('Client Type required.');

      return;
    }

    Server.sendGet('client/type/check', {
      clientTypeSeq: item?.clientTypeSeq,
      clientTypeName: item?.clientTypeName
    }, clientTypeCheckCallback).then();
  };

  const clientTypeCheckCallback = res => {
    if (res?.['resultCount'] === 0) {
      setIsIdCheck(true);

      Common.errorMsg('Available.');
    } else {
      Common.errorMsg('Client Type existing.');

      setItem(() => {
        return {
          ...item,
          clientTypeName: '',
        }
      });
    }
  };

  const clientTypeDelete = () => {
    if(!isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to delete?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            Server.sendPut('client/type', item, clientTypeDeleteCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const clientTypeDeleteCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  return (
    <>
      <CloseBtn onClick={closeModal} />
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Client type {props.props?.isRegi ? 'Registration' : 'Modify'}</h4>
          </TitHead>
        </Title>
        <ModalForm>
          <FormIn>
            <FormInWrap>
              <label><span>* </span>Client Type</label>
              <FormInput
                style={{ width: 'calc(70% - 10px)' }}
                type='text'
                id='clientTypeName'
                name='clientTypeName'
                value={item?.clientTypeName}
                onChange={e => {
                  setItem(() => {
                    return {
                      ...item,
                      clientTypeName: e.target.value,
                    }
                  });
                  setIsIdCheck(false);
                }}
              />
              <Btn
                style={{
                  flex: 'none',
                  width: '15%',
                  fontSize: '16px',
                  background: !isIdCheck ? '#0072b9' : '#a4a4a4'
                }}
                onClick={clientTypeCheck}
              >Check</Btn>
            </FormInWrap>
          </FormIn>
          <FormBtn $Btn>
            <Btn onClick={closeModal}>Cancel</Btn>
            {props.props?.isRegi === false &&
              <Btn $Delete onClick={clientTypeDelete}>delete</Btn>
            }
            <Btn $Color onClick={setClientType}>Submit</Btn>
          </FormBtn>
        </ModalForm>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  padding: 40px;
  width: 700px;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: content-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 100%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;

    & span {
      font-size: 11px;
      color: red;
    }
  }
`;

const FormInput = styled.input`
  width: calc(70% - 10px);
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : (props.$Delete ? '#FF4848' : '#a4a4a4'))};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : (props.$Delete ? '#FF2424' : '#7e7e7e'))};
  }
`;

export default ClientTypeModal;